import axiosInstance from 'api/axiosInstance';
import type { DocumentItem } from 'types/repository.types';

const getRepoDocumentById = (id: string): Promise<DocumentItem> =>
  axiosInstance.get(`/v2/repository-documents/${id}`);

export default getRepoDocumentById;
